import React from "react";
import { Box, Button } from "@mui/material";
import { BOTON_PRIMARIO_SX } from "../../../../components/ui/buttonStyles";
import FilterListIcon from "@mui/icons-material/FilterList";

/**
 * Componente de filtros para incidencias
 */
const FiltrosIncidencias = ({ soloAbiertas, onToggleFiltro }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Button
        variant="contained"
        startIcon={<FilterListIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />}
        onClick={onToggleFiltro}
        sx={BOTON_PRIMARIO_SX}
      >
        {soloAbiertas ? "Ver todas" : "Ver solo abiertas"}
      </Button>
    </Box>
  );
};

export default FiltrosIncidencias;
